<!-- eslint-disable -->
<template>
  <div>
    <v-app-bar color="primary">
      <div class="d-flex align-center app-w-100">
        <!-- collapse -->
        <v-btn
          v-if="showCollapseButton"
          small
          dark
          fab
          color="grey darken-4"
          class="mr-4"
          @click="onCollapseClicked"
        >
          <v-icon>mdi-menu</v-icon> </v-btn
        ><!-- collapse -->

        <v-img
          v-if="centeredLogo"
          height="34"
          src="../static/img/logo-lnf.svg"
          contain
          width="70%"
          class="justify-start align-start"
        ></v-img>

        <div class="d-flex ml-auto">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="showUserDropdown" class="d-flex align-center">
                <div class="me-2">
                  <p class="text-end ma-0" style="color: white; font-size: 12px">
                    {{ username }} <strong><i>{{ rolename }}</i></strong>
                  </p>
                  <v-layout v-if="showSupplierSelect" class="mt-1" justify-end>
                    <SupplierSelect/>
                  </v-layout>
                </div>
                <v-btn rounded icon dark v-bind="attrs" v-on="on">
                  <v-icon>mdi-account</v-icon>
                </v-btn>
              </div>
            </template>
            <v-list>
              <v-list-item @click="onSignOutClicked">
                <v-list-item-icon class="mx-0 mr-4">
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Sign Out</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

        </div>

      </div>
    </v-app-bar>
  </div>
</template>

<script>
import api from "../api";
import storage from "../storage";

export default {
  props: {
    showCollapseButton: {
      type: Boolean,
    },
    showUserDropdown: {
      type: Boolean,
    },
    showSupplierSelect: {
      type: Boolean,
      default: false,
    },
  }, // props
  data() {
    return {
      centeredLogo: false,
    };
  },

  computed: {
    rolename() {
      return storage.local.getUserRoleName()
    },
    supplierName() {
      return `${storage.local.getSupplierName()} (${storage.local.getSupplierInternalId()})`;
    },
    username() {
      return storage.local.getEmail();
    },
  }, // computed
  mounted() {
    if (this.$route.path.includes("login")) this.centeredLogo = true;
  },

  methods: {
    onCollapseClicked() {
      this.$emit("collapse");
    },

    onSignOutClicked() {
      api.auth.endUserSession().then(() => {
        this.$router.push({ path: "/login" });
      });

      // setTimeout(() => window.location.reload(), 1000);
    },
  }, // methods
};
</script>

<style>
</style>
